import { logger } from '../../../shared/logger';
import { EVENT_TYPES, tracker } from '../../../utils/bi/grafana';
import { LOGS_KEY } from '../../../utils/constants';

export const onDynamicImportError = ({ stackTrace, logMessage, funnelName, pageName }) => {
    logger.warn(stackTrace, {
        [LOGS_KEY]: logMessage,
    });

    tracker.initialize({ funnelName, pageName });
    tracker.trackCount('dynamic_import_failures', EVENT_TYPES.ERROR);
};
